import gql from "@/api/gql.js"
import { query, mutation } from "./queries.js"
import resolveApiErrors from "@/api/resolveApiErrors"

export default {
	async quotes(variables) {
		const res = await gql({
			query: query.quotes,
			variables
		})

		return resolveApiErrors({
			resolutionType: "queryWithList",
			res,
			resKey: "policies"
		})
	},

	async quote(variables) {
		const res = await gql({
			query: query.quote,
			variables
		})

		return resolveApiErrors({
			resolutionType: "queryWithList",
			res,
			resKey: "policies"
		})
	},

	async loadingSettings(variables) {
		const res = await gql({
			query: query.loadingSettings,
			variables
		})

		return resolveApiErrors({
			resolutionType: "queryWithList",
			res,
			resKey: "products_2"
		})
	},

	async exclusionsSettings(variables) {
		const res = await gql({
			query: query.exclusionsSettings,
			variables
		})

		return resolveApiErrors({
			resolutionType: "queryWithList",
			res,
			resKey: "products_2"
		})
	},

	async quoteTransactions(variables) {
		const res = await gql({
			query: query.quoteTransactions,
			variables
		})

		return resolveApiErrors({
			resolutionType: "queryWithList",
			res,
			resKey: "policies"
		})
	},

	async offers(variables) {
		const res = await gql({
			query: query.offers,
			variables
		})

		return resolveApiErrors({
			resolutionType: "queryWithList",
			res,
			resKey: "policies"
		})
	},

	async createQuote(variables) {
		const res = await gql({
			query: mutation.createQuote,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "initializePolicy"
		})
	},

	async addOffer(variables) {
		const res = await gql({
			query: mutation.addOffer,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "addOffer"
		})
	},

	async addLoading(variables) {
		const res = await gql({
			query: mutation.addLoading,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "addLoadingToOffer"
		})
	},

	async removeLoading(variables) {
		const res = await gql({
			query: mutation.removeLoading,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "removeLoadingFromOffer"
		})
	},

	async addExclusion(variables) {
		const res = await gql({
			query: mutation.addExclusion,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "addExclusionToOffer"
		})
	},

	async removeExclusion(variables) {
		const res = await gql({
			query: mutation.removeExclusion,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "removeExclusionFromOffer"
		})
	},

	async sendNotification(variables) {
		const res = await gql({
			query: mutation.sendNotification,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "sendNotification"
		})
	},

	async readRejectionSettings(variables) {
		const res = await gql({
			query: query.readRejectionSettings,
			variables
		})

		return resolveApiErrors({
			resolutionType: "queryWithList",
			res,
			resKey: "products_2"
		})
	},

	async rejectQuote(variables) {
		const res = await gql({
			query: mutation.rejectQuote,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "rejectQuote"
		})
	},

	async issuePolicy(variables) {
		const res = await gql({
			query: mutation.issuePolicy,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "issuePolicy"
		})
	},

	async validatePolicy(variables) {
		const res = await gql({
			query: query.validatePolicy,
			variables
		})

		return resolveApiErrors({
			resolutionType: "queryWithoutList",
			res,
			resKey: "validatePolicy_2"
		})
	},

	async convertOffer(variables) {
		const res = await gql({
			query: mutation.convertOffer,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "convertOffer"
		})
	},

	async removeOffer(variables) {
		const res = await gql({
			query: mutation.removeOffer,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "removeOffer"
		})
	},

	async initializeTransaction(variables) {
		const res = await gql({
			query: mutation.initializeTransaction,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithoutStatus",
			res,
			resKey: "initializeTransaction"
		})
	},

	async getPrice(variables) {
		const res = await gql({
			query: query.getPrice,
			variables
		})

		return resolveApiErrors({
			resolutionType: "queryWithList",
			res,
			resKey: "products_2"
		})
	},

	async quoteLogs(variables) {
		const res = await gql({
			query: query.quoteLogs,
			variables
		})

		return resolveApiErrors({
			resolutionType: "queryWithList",
			res,
			resKey: "policies"
		})
	},

	async updateQuote(variables) {
		const res = await gql({
			query: mutation.updateQuote,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "updatePolicy"
		})
	},

	async addInsured(variables) {
		const res = await gql({
			query: mutation.addInsured,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "addInsured"
		})
	},

	async removeInsured(variables) {
		const res = await gql({
			query: mutation.removeInsured,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "removeInsured"
		})
	},

	async addOtherHolder(variables) {
		const res = await gql({
			query: mutation.addOtherHolder,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "addOtherHolder"
		})
	},

	async removeOtherHolder(variables) {
		const res = await gql({
			query: mutation.removeOtherHolder,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "removeOtherHolder"
		})
	},

	async individual(variables) {
		const res = await gql({
			query: query.individual,
			variables
		})

		return resolveApiErrors({
			resolutionType: "queryWithList",
			res,
			resKey: "individuals"
		})
	},

	async company(variables) {
		const res = await gql({
			query: query.company,
			variables
		})

		return resolveApiErrors({
			resolutionType: "queryWithList",
			res,
			resKey: "companies"
		})
	},

	async addPaymentInfo(variables) {
		const res = await gql({
			query: mutation.addPaymentInfo,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "addPaymentInfo"
		})
	},

	async updatePaymentInfo(variables) {
		const res = await gql({
			query: mutation.updatePaymentInfo,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "updatePaymentInfo"
		})
	},

	async removePaymentInfo(variables) {
		const res = await gql({
			query: mutation.removePaymentInfo,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "removePaymentInfo"
		})
	},

	async updateOffer(variables) {
		const res = await gql({
			query: mutation.updateOffer,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "updateOffer"
		})
	},

	async checkOffer(variables) {
		const res = await gql({
			query: query.checkOffer,
			variables
		})

		return resolveApiErrors({
			resolutionType: "queryWithList",
			res,
			resKey: "policies"
		})
	},

	async deleteQuote(variables) {
		const res = await gql({
			query: mutation.deleteQuote,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "status"
		})
	}
}
